import React, { useEffect, useRef, useState } from "react";
import Dialog from "../../../components/Dialog/Dialog";
import { Fab, withStyles } from "@material-ui/core";
import { TextFieldSearch } from "../../../components/TextField";
import CloseIcon from "../../../components/Icon/Close";
import { Button } from "../../../components/ui/Buttons";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import {
  criarEImprimirDocumento,
  findAllDocumentoModelo,
  vincularEncaminhamento,
} from "../../../services/DocumentoService";
import { getProfissionalSaudeLogado } from "../../../services/UsuarioService";
import ModelDocumentEditor from "../../../components/ModelDocumentEditor";
import { ReactSelect } from "../../../components/Select/SelectSearch";
import InputForm from "../../../components/Input/InputForm";
import PrintIcon from "../../../components/Icon/Print";
import HorizontalLineIcon from "../../../components/Icon/HorizontalLineIcon";
import ImprimirPdf from "../../../components/Impressao/ImprimirPdf";
import { styles } from "./encaminhamentoModalStyles";
import { findAllEncaminhamentosModelo } from "../../../services/EncaminhamentoService";

let page = {
  pageNumber: 0,
  pageSize: 9999,
};

const EncaminhamentoModal = observer(
  ({
    classes,
    open,
    onClose,
    prontuarioStore,
    modeloDocumentoStore,
    handleMinimize,
    screen,
  }) => {
    const [documentos, setDocumentos] = useState([]);
    const [profissionalLogado, setProfissionalLogado] = useState([]);
    const [documento, setDocumento] = useState({});
    const [camposEntrada, setCamposEntrada] = useState([]);
    const [inputs, setInputs] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingModelos, setIsLoadingModelos] = useState(false);
    const [search, setSearch] = useState("");
    const [encaminhamentoTipo, setEncaminhamentoTipo] = useState(null);
    const [openMenu, setOpenMenu] = useState(true);
    const [isPrintPdf, setIsPrintPdf] = useState(false);
    const [pdfToPrint, setPdfToPrint] = useState(null);

    const editorRef = useRef(null);

    useEffect(() => {
      getDocumentosModelo("ENCAMINHAMENTO");
      getProfissionalSaude();
      setOpenMenu(true);
    }, []);

    const getModelosEncaminhamentos = async (
      search,
      loadedOptions,
      { page }
    ) => {
      const variables = {
        pageableDto: {
          pageNumber: page,
          pageSize: 10,
          sortDir: "ASC",
          sortField: "nome",
        },
        search,
        ativo: true,
      };

      const { content, last } = await findAllEncaminhamentosModelo(variables);

      return {
        hasMore: !last,
        options: content,
        additional: {
          page: page + 1,
        },
      };
    };

    const getProfissionalSaude = async () => {
      const profissionalLogado = await getProfissionalSaudeLogado();
      setProfissionalLogado(profissionalLogado);
    };

    const getDocumentosModelo = async (tipo) => {
      setIsLoadingModelos(true);
      try {
        const response = await findAllDocumentoModelo({
          ativo: true,
          search,
          pageableDTO: {
            ...page,
            sortDir: "ASC",
            sortField: "nome",
          },
          profissionalSaudeId: profissionalLogado.id,
          tipo: "ENCAMINHAMENTO",
        });
        setDocumentos(response?.content);
      } catch (error) {
        console.error(error);
        prontuarioStore.openNotification(
          "Erro ao carregar documentos modelo",
          "error"
        );
      } finally {
        setIsLoadingModelos(false);
      }
    };

    const handleSetCamposEntrada = (value) => {
      if (value) {
        const { camposEntrada } = value;
        setCamposEntrada(camposEntrada || []);
        if (camposEntrada?.length > 0) {
          let inputs = {};
          camposEntrada.forEach((campoEntrada) => {
            inputs[campoEntrada?.campo] = {
              valor: "",
              campo: campoEntrada.campo,
            };
          });
          setInputs(inputs);
        } else {
          setInputs(null);
        }
      }
      setIsLoading(false);
    };

    const handleDocumentoChange = (e) => {
      setIsLoading(true);
      setDocumento(e);
      handleSetCamposEntrada(e);
    };

    const handleClickImprimir = async () => {
      try {
        const modelDucumentChanged = editorRef.current.handleSubmitFromChild();
        const sujeitoAtencaoId = (screen = "Paciente - Prontuário"
          ? prontuarioStore.sujeitoAtencaoSelected.id
          : prontuarioStore?.agendamentoSelected?.sujeitoAtencao?.id);

        const variables = {
          sujeitoAtencao: {
            id: sujeitoAtencaoId,
          },
          documentoModelo: {
            modelo: modelDucumentChanged,
            nome: documento?.name,
            id: documento?.value,
          },
          camposEntrada: camposEntrada.reduce((acc, campo) => {
            const input = { ...inputs[campo.campo] };
            return input ? [...acc, input] : acc;
          }, []),
        };

        const response = (await criarEImprimirDocumento(variables)).data?.data
          ?.criarEImprimirDocumento;

        if (response?.id) {
          const variables = {
            documentoId: response.id,
            encaminhamentoId: encaminhamentoTipo?.id,
          };

          await vincularEncaminhamento(variables);

          prontuarioStore.openNotification("Salvo!", "success");
          setPdfToPrint(response?.pdf);
          setIsPrintPdf(true);
        } else {
          prontuarioStore.openNotification(
            "Erro ao salvar documento!",
            "error"
          );
        }
      } catch (error) {
        prontuarioStore.openNotification("Erro ao salvar documento!", "error");
        console.error(error);
      }
    };

    const handleInputClick = (event, field) => {
      let updatedInputs = inputs;
      updatedInputs[field] = { valor: event.target.value, campo: field };
      setInputs(updatedInputs);
    };

    const handleSelectChange = (e, field) => {
      setOpenMenu(false);
      setSearch(e);
      handleDocumentoChange(e);
    };

    const handleChange = (e) => {
      setEncaminhamentoTipo(e);
    };

    const LoadingMessage = (props) => {
      return (
        <div
          {...props.innerProps}
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            color: "#505050",
          }}
        >
          Carregando...
        </div>
      );
    };

    return (
      <Dialog open={open} onClose={onClose} classes={{ paper: classes.dialog }}>
        <div className={classes.header}>
          <div className={classes.title}>
            Novo Encaminhamento
            <div className={classes.contentIcons}>
              <Fab
                id="prt-enc-btn-min"
                size={"small"}
                style={{ background: "#707C97", color: "#FFF" }}
                onClick={handleMinimize}
              >
                {" "}
                <HorizontalLineIcon />{" "}
              </Fab>
              <Fab id="prt-enc-btn-fch" size={"small"} color={"secondary"} onClick={onClose}>
                <CloseIcon />
              </Fab>
            </div>
          </div>
          <div className={classes.input}>
            <label className={classes.label}>Pesquisar encaminhamentos</label>
            <TextFieldSearch
              id="prt-enc-sel-enc"
              classNotched={classes.notchedOutline}
              classeInput={classes.inputContainer}
              placeholder={"selecione"}
              loadOptions={getModelosEncaminhamentos}
              withPaginate
              getOptionLabel={(option) => option?.nome}
              getOptionValue={(option) => option?.id}
              value={encaminhamentoTipo}
              onChange={(e) => handleChange(e, "encaminhamentoTipo")}
              debounceTimeout={300}
              additional={{
                page: 0,
              }}
              menuPosition="fixed"
            />
          </div>
          <div
            id="prt-enc-div-doc"
            className={classes.select}
            onClick={() => setOpenMenu(!openMenu)}
          >
            <label className={classes.label}>Pesquisar documentos</label>
            <ReactSelect
              id="prt-enc-sel-doc"
              autoFocus
              customStylesSelect={{
                menu: {
                  maxHeight: "300px",
                  border: "1px solid #8686869f",
                },
              }}
              menuIsOpen={openMenu}
              className={classes.selectDocumento}
              value={documento}
              options={documentos || []}
              onChange={(e) => handleSelectChange(e, "ONCHANGE")}
              getOptionLabel={(option) => option.label}
              placeholder={"selecione"}
              components={{ LoadingMessage }}
              isLoading={isLoadingModelos}
            />
          </div>
          {documento && camposEntrada.length > 0 && (
            <div className={classes.inputsContainer}>
              {camposEntrada.map((input) => (
                <div
                  key={`input-document-${input.campo}`}
                  className={classes.inputLabel}
                >
                  <label>{input.campoAmigavel}</label>
                  <InputForm
                    id={`prt-enc-inp-cmp-${input.campo}`}
                    error={
                      inputs && inputs[input.campo]
                        ? inputs[input.campo]?.error
                        : null
                    }
                    onChange={(e) => handleInputClick(e, input.campo)}
                    placeholder={input.campoAmigavel}
                    classes={{ input: classes.InputForm }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>

        {documento?.modelo && !isLoading && (
          <div className={classes.dialogContent}>
            <ModelDocumentEditor
              classes={{
                textAreaWrapper: classes.textEditorWrapper,
                scrollEditor: classes.textEditorScroll,
                editor: classes.editor,
                jodit: classes.jodit,
              }}
              id={documento?.value}
              key={documento?.value}
              refChild={editorRef}
              disabledButtons={["image"]}
              textoHtml={prontuarioStore.previewDocumento?.content?.documento}
              modeloDocumentoStore={modeloDocumentoStore}
            />
          </div>
        )}
        <div className={classes.contentButton}>
          <Button
            id="prt-enc-btn-imp"
            className={classes.buttonImprimir}
            onClick={() => handleClickImprimir()}
            disabled={!encaminhamentoTipo?.id || !documento?.modelo}
          >
            <PrintIcon />
            Imprimir
          </Button>
        </div>
        {isPrintPdf && pdfToPrint && (
          <ImprimirPdf
            pdfBase64={pdfToPrint}
            onAfterPrint={() => {
              setIsPrintPdf(false);
              setPdfToPrint(null);
              onClose();
            }}
          />
        )}
      </Dialog>
    );
  }
);

const stores = [
  "filtroHeaderStore",
  "usuarioStore",
  "prontuarioStore",
  "modeloDocumentoStore",
];
const EncaminhamentoWithStyles = withStyles(styles)(EncaminhamentoModal);
export default inject(...stores)(EncaminhamentoWithStyles);
